import { Location } from "gen/company/models_pb"
import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { Order_Status as OrderStatus } from "gen/txn/models_pb"
import { UUID } from "shared-ts/classes/uuid"
import { QueryParams, WebUrl } from "shared-web/lib/webUrl"

import { encodeQueryParam } from "hooks/filters/useWebFilter"

import { cleanStatus } from "./cleanStatus"

const statusSegments: Record<OrderStatus, string> = {
  [OrderStatus.UNDEFINED]: "new",
  [OrderStatus.CREATED]: "drafts",
  [OrderStatus.ORDERED]: "ordered",
  [OrderStatus.RECEIVED]: "received",
  [OrderStatus.VOIDED]: "voided",
}

export function orders(
  status: OrderStatus = OrderStatus.UNDEFINED,
  location?: Pick<Location, "id" | "name">
): WebUrl {
  const pathname = `/pos/purchase-orders/${statusSegments[status]}`

  if (!location) {
    return { pathname }
  }

  const query: QueryParams = {
    locations: encodeQueryParam(
      {
        key: UUID.idString(location.id),
        value: location.name,
      },
      true
    ),
  }

  return { pathname, query }
}

export function order(id?: PBUUID, status?: OrderStatus): WebUrl {
  if (!id) {
    return { pathname: `/pos/purchase-orders/new` }
  }

  const pathname = `/pos/purchase-orders/${UUID.idString(id)}`
  const statusParam = orderStatusParam(status)

  if (!statusParam) {
    return { pathname }
  }

  return {
    pathname,
    query: { status: statusParam },
  }
}

export function orderStatusParam(status?: OrderStatus): string {
  if (!status) {
    return ""
  }
  return cleanStatus(OrderStatus[status])
}

export function buyersList(): WebUrl {
  return {
    pathname: "/pos/purchase-orders/buyers-list",
  }
}
